import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["marathon-taper"]!;

export function Body() {
  return (
    <>
      <p>
        In the last weeks before a marathon it is tempting to squeeze in one more long run. A
        study of more than 158,000 marathon runners suggests that easing off earlier may pay
        off on race day.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers in Dublin looked at the training logs of recreational marathon runners in
        the weeks before their race. They compared runners who cut their weekly distance
        steadily over the last three weeks with runners who barely tapered at all.
      </p>

      <h2>What they found</h2>
      <p>
        Runners who reduced their distance week by week for three weeks finished about 2.6
        percent faster than comparable runners with a minimal taper. For a four-hour marathon
        that is around six minutes. The association was larger among women than men.
      </p>
      <p>
        Most runners didn't taper like that. About two thirds had a shorter or less consistent
        taper.
      </p>

      <h2>What it means for you</h2>
      <p>
        A gradual reduction over the last three weeks is one option to consider for a marathon,
        alongside your training history and recovery. Resist the urge to make up for missed
        training in the final weeks. The study does not tell you to stop training or establish
        one ideal taper for every runner.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The study compares runners who chose different tapers. It can't rule out that the
        runners who tapered well were also better prepared in other ways. It also says nothing
        about shorter races, where a shorter taper is usually enough. Elite marathon runners
        often start their taper 7 to 10 days before the race, but they also train far more than
        most of us.
      </p>

      <h2>How we use it</h2>
      <p>
        In PX7 Training the taper is planned backwards from your race date, and the length
        depends on the race distance. When a plan is rebuilt after a break, the taper still
        lines up with race day.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Smyth & Lawlor (2021), Longer disciplined tapers improve marathon performance for
          recreational runners.{" "}
          <a href="https://doi.org/10.3389/fspor.2021.735220">Frontiers in Sports and Active Living</a>.
        </li>
        <li>
          Haugen et al. (2022), The training characteristics of world-class distance runners.{" "}
          <a href="https://doi.org/10.1186/s40798-022-00438-7">Sports Medicine – Open</a>.
        </li>
      </ul>
    </>
  );
}
